import styled from 'styled-components'
import AppButton from 'Components/AppButton'
import { IS_MRLOFT } from 'Config/config'
import { TitleValueBlockV2 } from 'Layout'
import { PRIMARY_DARK_COLOR, FAV_AREA_BG_COLOR } from '@CSSVars/colors'
import {
  BREAK_POINT_MD,
  BREAK_POINT_LG,
} from '@CSSVars/variables'

export const _PreconPricingContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 50px;
  padding-top: 16px;

  @media screen and (max-width: ${BREAK_POINT_LG}) {
    flex-direction: column;
  }
`
export const _Title = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  margin-bottom: 20px;
  color: inherit;
`

export const _PricingDepositContainer = styled.div`
  display: flex;
  flex-direction: ${({ isListingPage }) => (isListingPage ? 'column' : 'row')};
  width: ${({ isListingPage }) => (isListingPage ? '50%' : '66%')};
  gap: 32px;
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    width: 100%;
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    flex-direction: column;
    ${_Title} {
        margin-bottom: 24px;
    }
  }

`

export const _PricingContainer = styled.div`
  width: ${({ isListingPage }) => (isListingPage ? '100%' : '50%')};
  @media screen and (max-width: ${BREAK_POINT_MD}) {
   width: 100%;
   margin-top: 2px;
  }

`

export const _DepositStructureContainer = styled.div`
  width: ${({ isListingPage }) => (isListingPage ? '100%' : '50%')};
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    width: 100%;
    margin-top: 8px;
  }

`

export const _IncentivesContainer = styled.div`
  background: ${IS_MRLOFT ? 'rgba(191, 60, 72, 0.1)' : FAV_AREA_BG_COLOR};
  padding: 24px;
  border-radius: 10px;
  width: ${({ isListingPage }) => (isListingPage ? '50%' : '33%')};
  display: flex;
  flex-direction: column;
  justify-content: start;
  height: fit-content;
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    width: 100%;
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    margin-top: 12px;
  }

`

export const _IncentiveText = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 26px;
  margin-bottom: 12px;
  color: inherit;
`

export const _IncentiveItem = styled.div`
  svg {
    margin-right: 14px;
    fill: ${PRIMARY_DARK_COLOR};
  }
  margin-bottom: 16px;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;

`
export const _TitleValueBlock = styled(TitleValueBlockV2)`
  margin-bottom: 12px;
  > div > div {
    font-weight: 500;
    text-wrap: auto;
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    margin-bottom: 24px;
    width: 50%;
    white-space: break-spaces;
  }
`
export const _ContactCTA = styled(AppButton)`
  margin-top: 8px;
  width: 100%;
  height: 44px;
`

export const _DepositText = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;


`
